/**
 * Labstep
 *
 * @module core/Card/EmptyState
 * @desc Skeleton for empty state warnings
 */

import classnames from 'classnames';
import { Header } from 'labstep-web/core/Header';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { EmptyStateProps } from './types';

export const CardEmptyState: React.FC<EmptyStateProps> = ({
  title,
  src,
  explanation,
  action,
  secondaryAction,
  warning,
  stackedActions = false,
  dataCy,
}) => (
  <div
    data-cy={dataCy || 'core/Card/EmptyState'}
    className={styles.main}
    data-testid="empty-state"
    data-public
  >
    <Image data-public src={src} fluid />
    {title && (
      <Header size="xsmall" color={warning ? 'red' : undefined}>
        {title}
      </Header>
    )}
    <p data-public>{explanation}</p>
    <div
      className={classnames(styles.actions, {
        [styles.stackedActions]: stackedActions,
        [styles.withoutSecondaryAction]: !secondaryAction,
      })}
    >
      <div data-public>{action}</div>
      {secondaryAction && <div data-public>{secondaryAction}</div>}
    </div>
  </div>
);
